import { render, staticRenderFns } from "./SearchCollapse.vue?vue&type=template&id=bdd69f6c&"
import script from "./SearchCollapse.vue?vue&type=script&lang=js&"
export * from "./SearchCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports